import {getClassLastLesson, getClassLastLessonId, getClassLesson} from "../../../network/Endpoint";
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import { mainClassState } from "../../../recoil/classes/classesState";
import {useEffect, useRef, useState} from "react";
import StageBadge from "../components/classLesson/StageBadge";
import {
    gradeState,
    semesterState,
    lessonState,
} from "../../../recoil/lesson/lessonState";
import CurriculumDropdown from "../components/classLesson/CurriculumDropdown";
import {topMenuTypeState} from "../../../recoil/menuState/topMenuState";
import Filter from "../../../assets/images/fillter.png"
import {classLearningMenuState} from "../../../recoil/menuState/classLearningMenuState";
import {useNavigate} from "react-router-dom";
import SideMenu from "../../../components/SideMenu";
import {teacherGradeState, teacherSemesterState} from "../../../recoil/teacher/teacherIdState";
import {curriculumState} from "../../../recoil/curriculums/curriculumState";

const ClassLessonPage = () => {
    const curriculumData = useRecoilValue(curriculumState);
    const mainClass = useRecoilValue(mainClassState);
    const [lessonStageResults, setLessonStageResults] = useState([]);
    const [grade, setGrade] = useRecoilState(gradeState);
    const [semester, setSemester] = useRecoilState(semesterState);
    const teacherGrade = useRecoilValue(teacherGradeState);
    const teacherSemester = useRecoilValue(teacherSemesterState);
    const [lessonInfoId, setLessonInfoId] = useRecoilState(lessonState);
    const classLearningMenu = useRecoilValue(classLearningMenuState);
    const [activeCount, setActiveCount] = useState(0);

    const [isFirstLoad, setIsFirstLoad] = useState(true); // ✅ 최초 로딩 여부 추가

    const setMenuType = useSetRecoilState(topMenuTypeState);

    const [showTabType, setShowTabType] = useState(0);

    const navigate = useNavigate();

    /** ✅ 최초 수업 데이터를 서버에서 가져와 설정 */
    const fetchLastClassLesson = async () => {
        if (!mainClass || !mainClass.classId) return; // ✅ mainClass가 없으면 실행 안 함
        if(classLearningMenu !== "lesson"){
            return;
        }

        try {
            const body = { classId: mainClass.classId };
            const res = await getClassLastLessonId(body);
            const statusCode = res.data.status.code;

            if (statusCode === "Success") {
                const data = res.data.data;
                if(data.lessonInfoId){
                    setLessonInfoId(data.lessonInfoId);
                }else{
                    setLessonInfoId(curriculumData.lessonSemesterList[(teacherGrade-1)*2+teacherSemester -1].lessonChapters[0].lessons[0].lessonInfoId);
                }
                setIsFirstLoad(false); // ✅ 첫 번째 API 요청이 끝났음을 표시

            } else{

                alert(`ERROR: 학생 정보 로드 중 오류가 발생했어요. 아크수학으로 문의해 주세요.\n${res.data.status.message}`);
            }
        } catch (error) {
            alert(`[${error.message}]\n 학생 정보 로드 중 오류가 발생했어요.\n아크수학으로 문의해 주세요.`);
        }
    };

    /** ✅ lessonInfoId가 변경될 때 서버에서 새 데이터 가져오기 (최초 실행 제외) */
    const fetchGetClassLesson = async () => {
        if (!lessonInfoId || isFirstLoad) return; // ✅ 최초 실행 시에는 실행하지 않음
        if(classLearningMenu !== "lesson"){
            return;
        }
        try {
            const body = { classId: mainClass.classId, lessonInfoId };
            const res = await getClassLesson(body);
            const statusCode = res.data.status.code;

            if (statusCode === "Success") {
                const data = res.data.data;
                setLessonStageResults(data.lessonStageResults);
                setGrade(data.lessonStageResults[0].lessonInfo.grade);
                setSemester(data.lessonStageResults[0].lessonInfo.semester);
                setLessonInfoId(data.lessonStageResults[0].lessonInfo.lessonInfoId);
                setActiveCount(data.activeCount?data.activeCount : 0);
            } else {
                alert(`ERROR: 학생 정보 로드 중 오류가 발생했어요. 아크수학으로 문의해 주세요.\n${res.data.status.message}`);
            }
        } catch (error) {
            alert(`[${error.message}]\n 학생 정보 로드 중 오류가 발생했어요.\n아크수학으로 문의해 주세요.`);
        }
    };

    /** ✅ mainClass가 변경될 때 최초 1회 실행 */
    useEffect(() => {
        if (mainClass && mainClass.classId) {
            if(lessonInfoId){
                setIsFirstLoad(false); // ✅ 첫 번째 API 요청이 끝났음을 표시
                fetchGetClassLesson();
            }else{
                fetchLastClassLesson();
            }
        }
    }, [mainClass]); // ✅ mainClass가 변경될 때 실행됨


    /** ✅ lessonInfoId 변경될 때마다 새로운 데이터 가져오기 (최초 실행 제외) */
    useEffect(() => {
        if(!isFirstLoad){
            fetchGetClassLesson();
        }
    }, [lessonInfoId, isFirstLoad]);

    useEffect(() =>  {
        if(setMenuType){
            setMenuType("classLesson");
        }
    },[setMenuType])

    useEffect(() => {
        if(classLearningMenu==="homework"){
            navigate("/page/classHomework");
        }else if(classLearningMenu==="daily"){
            navigate("/page/classDaily");
        }
    },[classLearningMenu])

    return (
        <div className="flex flex-col items-center w-full max-md:max-w-full bg-[#F8F8F8] min-h-screen">
            {/* 드롭다운 메뉴 */}
            <div className="flex flex-row justify-center items-center max-w-[1044px] w-full mt-12 mb-10 gap-3">
                <div className="relative w-[1027px] h-[44px] ">
                    <CurriculumDropdown
                        grade={grade}
                        setGrade={setGrade}
                        semester={semester}
                        setSemester={setSemester}
                        lessonInfoId={lessonInfoId}
                        setLessonInfoId={setLessonInfoId}
                        isFirstLoad={isFirstLoad}
                        setShowTabType={setShowTabType}
                        pageType="lesson"
                    />
                </div>
            </div>

            <div
                className="flex flex-row items-center justify-center gap-3  text-center text-[16px] mt-3"
            >
                <img
                    src={Filter}
                    alt="filter icon"/>
                <div
                    className={`flex py-2 px-5 justify-center items-center gap-2 cursor-pointer border-[2px] rounded-[10px]
                    ${showTabType === 0
                    ? 'bg-white text-[#355BDF] border-[#7494FF]'
                    : 'bg-[#D7E5FE] text-[#50555F] border-[#D7E5FE]'
                    }`}
                    onClick={() => setShowTabType(0)}
                >
                    <div
                        className=" font-[700]"
                    >전체 보기
                    </div>
                    <div className="text-[#174CD4] font-[900]">
                        {lessonStageResults && lessonStageResults.length}
                    </div>
                </div>
                <div
                    className={`flex py-2 px-5 justify-center items-center gap-2 cursor-pointer border-[2px] rounded-[10px]
                    ${showTabType === 1
                        ? 'bg-white text-[#757d8d] border-[#DDD]'
                        : 'bg-[#DFDFDF] text-[#50555F] border-[#DFDFDF]'
                    }`}
                    onClick={() => setShowTabType(1)}
                >
                    <div
                        className="font-[700]"
                    >
                        미진행한 수업
                    </div>
                    <div className="text-[#8E8E8E] font-[900]">
                        {lessonStageResults&&lessonStageResults.length - activeCount}
                    </div>
                </div>
                <div
                    onClick={() => setShowTabType(2)}
                    className={`flex py-2 px-5 justify-center items-center gap-2 cursor-pointer border-[2px] rounded-[10px]
                    ${showTabType === 2
                        ? 'bg-white text-[#008351] border-[#00C472]'
                        : 'bg-[#D1F4DE] text-[#50555F] border-[#D1F4DE]'
                    }`}
                >
                    <div
                        className="font-[700]"
                    >
                        진행한 수업
                    </div>
                    <div className="text-[#009D38] font-[900]">
                        {activeCount && activeCount}
                    </div>
                </div>

            </div>

            {/* 스테이지 정보 부분 */}
            <div className="flex max-w-[1044px] w-full mt-3 mb-40">
                <div className="flex flex-row justify-between flex-wrap w-full">
                    {(() => {
                        const filteredResults = lessonStageResults && lessonStageResults.length > 0
                            ? lessonStageResults.filter(result => {
                                if (showTabType === 1) return result.activeDate === null;
                                if (showTabType === 2) return result.activeDate !== null;
                                return true; // showTabType === 0일 때 전체 표시
                            })
                            : [];

                        return filteredResults.length > 0 ? (
                            filteredResults.map((result, index) => (
                                <StageBadge
                                    key={index}
                                    index={index}
                                    grade={grade && grade}
                                    semester={semester && semester}
                                    stageSummary={result}
                                    classInfo={mainClass}
                                    notStartedComment="아직 수업을 진행하지 않았어요"
                                />
                            ))
                        ) : (
                            <div
                                className="flex flex-row items-center w-full rounded-[20px] bg-white border-[1px] border-[#DADADA] h-[78px] p-5 gap-3 mt-3">
                                <div
                                    className="flex justify-center items-center text-black text-[18px] font-[500] h-[34px] p-2 w-full">
                                    학습한 내역이 없습니다.
                                </div>
                            </div>
                        );
                    })()}
                </div>
            </div>
            <SideMenu></SideMenu>
        </div>
    );
};

export default ClassLessonPage;
